import gql from 'graphql-tag'

export const GET_GIFT_CARD_BY_CODE = gql`
  query GetGiftCardByCode($code: String!, $organizationId: ID!) {
    getGiftCardByCode(code: $code, organizationId: $organizationId) {
      id
      code
      initialAmount
      amount
      currency
      active
    }
  }
`
